import React from 'react';
export function ServicesSection() {
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-213">
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-214">
        <div data-id="element-215">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-216">Serviços</h2>
          <p className="text-gray-600 mb-6" data-id="element-217">
            Acesso a serviços e informações relacionadas com o mar
          </p>
          <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-218">
            Ver mais
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-219">
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-220">
            <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600" alt="Serviços Marítimos" className="w-full h-full object-cover" data-id="element-221" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-4 text-white" data-id="element-222">
              <h3 className="font-bold mb-2" data-id="element-223">Licenciamento</h3>
              <button className="bg-white text-blue-900 px-3 py-1 rounded text-sm font-semibold w-fit" data-id="element-224">
                Explorar
              </button>
            </div>
          </div>
          <div className="relative h-48 rounded-lg overflow-hidden" data-id="element-225">
            <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600" alt="Certificações" className="w-full h-full object-cover" data-id="element-226" />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-4 text-white" data-id="element-227">
              <h3 className="font-bold mb-2" data-id="element-228">Certificações</h3>
              <button className="bg-white text-blue-900 px-3 py-1 rounded text-sm font-semibold w-fit" data-id="element-229">
                Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}